import { render } from "./LoadingSpinner.vue?vue&type=template&id=f87bd570&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=f87bd570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87bd570"]])

export default __exports__